(() => {
	angular
		.module('main')
		.controller('IntegrationsController', IntegrationsController);

	IntegrationsController.$inject = ['$scope', '$routeParams'];

	function IntegrationsController($scope, $routeParams) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.routeParams = $routeParams;
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/integrationsController.js